import * as React from 'react';
import { Button, Form, Input, Checkbox, Segment, Label, Modal } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth from '../../../api';
// @ts-ignore
import * as PasswordMask from 'react-password-mask';
import '../../../panels/panels.css';
import Toast from '../../../sys/toast';

class State {
    httpPortEnable: boolean;
    httpMgmtOnly: boolean;
    httpPort: any;
    httpsPort: any;
    httpTimeout: any;
    showModal: boolean;
    modalContent: any;
    file: any;
    passphrase: string;
    modalHeader: string;
}

interface Props {

}

export default class NtwrkConfigPanel extends React.Component<Props, State> {

    private httpPortEnable: any; private httpPort: any; private httpsPort: any;
    private httpTimeout: any; private httpMgmtOnly: any;

    componentWillMount() {
        this.setState({
            httpPort: '',
            modalContent: '',
            httpsPort: '',
            httpTimeout: '',
            showModal: false,
            file: null,
            passphrase: '',
            modalHeader: ''
        },
                      () => {this.getPassphrase(); this.fetchData(); }
        );
        this.handleChange = this.handleChange.bind(this);
    }

    restart() {
        let message = 'Restarting...please wait.';
        axios.post('http://default/api/sys/restart', {
            'save': true
        },         {
            headers: {
                'x-meta-caption': message // triggers loader during the request
            }
        })
            .then( (response: AxiosResponse) => {
                if (response.data !== undefined && response.data.code === 'SUCCESS' ) {
                    // must show popup and wait for the server to respond again
                    const { oauth, key } = OAuth.getContextFromResponseObject(response);
                    if (oauth) {
                        oauth.waitforServer({message: 'Waiting for restart to complete...'}, key)
                        // .then()   // could use then() to capture a success condition but shouldnt happen since we expect a reboot
                        // tslint:disable-next-line:no-console
                            .catch(er => console.log(er));  // this is always called if the server reboot succeeds (but we get redirected to login anyway)
                    }

                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('restart error: ', error);
            });
    }
    updateConfig(e: any, reset: boolean) {
        e.preventDefault();
        this.importCert(reset);
        this.updateHTTPPortInfo(reset);
        if (reset) {
            this.restart();
        }
    }

    importCert(reset: boolean) {
        // if (this.state.passphrase !== '' && this.state.passphrase !== this.passphrase) {
        this.savePassphrase();
        // }
        let _this = this;
        const url = 'http://default/api/sys/ssl/import';
        let formData = new FormData();
        formData.append('fileData', this.state.file);
        if (this.state.file) {
            axios.put(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('SSL Certificate applied');
                } else throw response;
            })
                .catch(error => {
                    _this.setState({
                        showModal: true,
                        modalContent: (error && error.response && error.response.data) ? error.response.data.det : 'Operation aborted, unspecified error performing import',
                        modalHeader: 'Error!',
                    });

                });
        }
    }

    updateHTTPPortInfo(reset: boolean) {
        let url = 'http://default/api/config/section/options/port';
        axios.post(url, {
            mode: 'modify',
            defaults: {
            },
            options: [
                { 'name': 'httpPortEnable', 'value': this.state.httpPortEnable },
                { 'name': 'httpMgmtOnly', 'value': this.state.httpMgmtOnly },
                { 'name': 'httpPort', 'value': this.state.httpPort },
                { 'name': 'httpsPort', 'value': this.state.httpsPort },
                { 'name': 'httpTimeout', 'value': this.state.httpTimeout }
            ]
        })
            .then( (response: AxiosResponse) => {
                if (response.data !== undefined && response.data.code === 'SUCCESS' ) {
                    /*if (!reset) {
                        __this.setState({
                            showModal: true,
                            modalHeader: 'Apply',
                            modalContent: 'Changes do not take effect until the probe is restarted.'
                        });
                    }*/
                    if (reset)
                        Toast.info('HTTP configuration applied');
                    else
                        Toast.info('HTTP configuration applied. Changes do not take effect until configuration changes are saved and the probe is restarted.');
                    this.fetchData();
                } else {
                    Toast.error('HTTP configuration failed');
                }
            })
            .catch(error => {
                Toast.error('HTTP configuration failed');
            });
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/port';
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options: [
                'httpPortEnable',
                'httpMgmtOnly',
                'httpPort',
                'httpsPort',
                'httpTimeout'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;
                    const { oauth } = OAuth.getContextFromResponseObject(response);

                    _this.httpPortEnable = responseObject[0].value;
                    _this.httpMgmtOnly = responseObject[1].value;
                    _this.httpPort = responseObject[2].value;
                    _this.httpsPort =  responseObject[3].value;
                    _this.httpTimeout = responseObject[4].value;

                    if (oauth)
                        oauth.setIdleTimeout(parseInt(_this.httpTimeout, 10) * 60000);

                    _this.setState({
                        httpPortEnable: _this.httpPortEnable,
                        httpMgmtOnly: _this.httpMgmtOnly,
                        httpPort: parseInt(_this.httpPort, 10),
                        httpsPort: parseInt(_this.httpsPort, 10),
                        httpTimeout: parseInt(_this.httpTimeout, 10)
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }

    handleModalClose() {
        this.setState({
            showModal: false
        });
    }

    savePassphrase() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/sys/ssl/key';
        axios.post(url, {
            key: this.state.passphrase
        })
            .then( function(response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS' ) {
                    __this.getPassphrase();
                } else throw response;
            })
            .catch(error => {
                __this.setState({
                    showModal: true,
                    modalHeader: 'Error!',
                    modalContent: (error && error.response && error.response.data) ? error.response.data.det : 'Operation aborted, unspecified error saving passphrase',
                });
            });
    }

    getPassphrase() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/sys/ssl/key';
        axios.get(url)
            .then( function(response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS' ) {
                    // __this.passphrase = response.data.key;
                    __this.setState({
                        passphrase: response.data.key
                    });
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('ssl key error, got: ', error);
            });
    }

    handleChange(e: any) {
        this.setState({
            passphrase: e.target.value
        });
    }

    render() {
        const inlineStyle = {
            modal : {
                marginTop: '20px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        return (
            <React.Fragment>
                <div className="assetAliasFilters">
                    <Label className="system-config-pageHeader">
                        Network Ports
                    </Label>
                    <Button
                        floated="right"
                        className="rightButton"
                        content="Apply & Restart"
                        title="Apply & Restart"
                        onClick={(e, data) => this.updateConfig(e, true)}
                    />
                    <Button
                        floated="right"
                        className="rightButton"
                        content="Apply"
                        title="Update Config"
                        onClick={(e, data) => this.updateConfig(e, false)}
                    />
                </div>

                <Segment.Group className="system-config-segment">
                    <Segment className="segment-header">User Interface</Segment>
                    <Segment>
                        <Form>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    HTTP Port
                                </Label>
                                <Input
                                    className="system-config-segment-input"
                                    maxLength={5}
                                    disabled={true}
                                    value={this.state.httpPort}
                                    onChange={(e: any, data: any) => this.setState({httpPort: data.value})}
                                />
                                <Checkbox
                                    className="system-config-segment-network-checkbox"
                                    label="enable"
                                    checked={this.state.httpPortEnable}
                                    onChange={(e: any, data: any) => this.setState({httpPortEnable: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    HTTPS Port
                                </Label>
                                <Input
                                    className="system-config-segment-input"
                                    maxLength={5}
                                    value={this.state.httpsPort}
                                    onChange={(e: any, data: any) => this.setState({httpsPort: data.value})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    Accessible only over management interface
                                </Label>
                                <Checkbox
                                    // className="system-config-segment-network-checkbox"
                                    // label="HTTP access over management port only"
                                    checked={this.state.httpMgmtOnly}
                                    onChange={(e: any, data: any) => this.setState({httpMgmtOnly: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    Inactivity Timeout (minutes)
                                </Label>
                                <Input
                                    className="system-config-segment-input"
                                    maxLength={9}
                                    value={this.state.httpTimeout}
                                    onChange={(e: any, data: any) => this.setState({httpTimeout: data.value})}
                                />
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>
                <Segment.Group className="system-config-segment">
                    <Segment className="segment-header">
                        SSL Certificate
                    </Segment>
                        <Segment className="gray-background">
                            <Form>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        New Certificate
                                    </Label>
                                    <Input
                                        className="system-config-segment-fileField"
                                        type="file"
                                        onChange={(e: any) => this.setState({file: e.target.files[0]})}
                                    />
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Passphrase (Optional)
                                    </Label>
                                    <PasswordMask
                                        name="passphrase"
                                        className="password-mask-width"
                                        placeholder="Enter passphrase"
                                        value={this.state.passphrase}
                                        onChange={this.handleChange}
                                    />
                                </Form.Group>
                            </Form>
                        </Segment>
                </Segment.Group>
                <Modal
                    open={this.state.showModal}
                    onClose={this.handleModalClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>{this.state.modalHeader}</Modal.Header>
                    <Modal.Content>
                        {this.state.modalContent}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn" onClick={() => this.handleModalClose()}>
                            OK
                        </Button>
                    </Modal.Actions>
                </Modal>
            </React.Fragment>
        );
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/system/networkConfig.tsx